//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import RbModal from '@/elements/modal/rb-modal.vue'
import { createNamespacedHelpers } from 'vuex'
import { ACTION_HIDE_DOCTOR_LOCATOR } from '@/scripts/store/doctor-locator/actions'

const { mapGetters: mapGettersDoctorLocator, mapActions: mapActionsDoctorLocator } =
  createNamespacedHelpers('doctorLocator')

import wcs from '@/scripts/libs/wcs'

const { doctorLocator } = wcs.getStoreConfig()

export default {
  name: 'rb-doctor-locator',
  components: {
    RbModal,
  },
  data() {
    return {
      script: doctorLocator.script,
    }
  },
  computed: {
    ...mapGettersDoctorLocator(['isVisible']),
    allow() {
      const url = new URL(this.script)
      return `fullscreen; geolocation ${url.origin};`
    },
  },
  methods: {
    ...mapActionsDoctorLocator({
      hideDoctorLocator: ACTION_HIDE_DOCTOR_LOCATOR,
    }),
    closeModal() {
      this.hideDoctorLocator()
    },
  },
}
